import { render, staticRenderFns } from "./FirstBlockPromo.vue?vue&type=template&id=1f902619&scoped=true"
import script from "./FirstBlockPromo.vue?vue&type=script&lang=js"
export * from "./FirstBlockPromo.vue?vue&type=script&lang=js"
import style0 from "./FirstBlockPromo.vue?vue&type=style&index=0&id=1f902619&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f902619",
  null
  
)

export default component.exports